import axios from "axios";

import Cookies from 'js-cookie';
const API_URL = "https://cloud.gmi-aero.com:5000/auth/";

class AuthService {
    
  login(ausr_login, ausr_pwd) {
    const transport = axios.create({
        withCredentials: true
      })
    return transport
      .post(API_URL+'login' , {
        ausr_login,
        ausr_pwd
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("auth", JSON.stringify(response.data));
           }
           
           localStorage.setItem("token", response.cookie);
         
           localStorage.setItem("auth", JSON.stringify(response.data));
         

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("auth");
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password
    });
  }

  getCurrentUser() {

    return JSON.parse(localStorage.getItem('auth'));;
  }
}

export default new AuthService();